// A blank TipTap/ProseMirror doc — the initial content of a fresh text block (TODO §2.2).
// One empty paragraph, matching TipTap's own default document so the editor mounts clean.
// Mirrors griddSeed.ts's role for grid bodies: a valid starting document, not null.
export function emptyTextDoc(): unknown {
  return { type: "doc", content: [{ type: "paragraph" }] };
}
